import { VOTE_METHOD_FETCH_REQUEST } from 'store/constants/voteMethodTypes';

export function fetchVoteMethodsAction({ groupId }: any) {
  return {
    type: VOTE_METHOD_FETCH_REQUEST,
    payload: { groupId },
  };
}
